import { Injectable, InjectionToken } from "@angular/core";
import { OfferGetQueryResult, OfferListGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IOfferApiService {
  abstract offerListGetAsync(loadReferences: boolean, orderDateMinimum: Date | undefined): Promise<OfferListGetQueryResult>;

  abstract offerGetByDidAsync(integraBelegDid: string | undefined): Promise<OfferGetQueryResult>;

  abstract offerGetbyNrAsync(webshopOfferNumber: string | undefined, integraOfferNumber: string | undefined): Promise<OfferGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IOfferApiServiceToken = new InjectionToken<IOfferApiService>('IOfferApiServiceToken');
